export default "__VITE_ASSET__CFKegcct__"